angular.module('bizmetryApp').service('TwoFaService', [
    '$http', '$q', 'CONFIG',
    function ($http, $q, CONFIG) {

        const BASE_URL = CONFIG.BIZMETRY_BACKEND_URL + '/v1/api/bizmetry-account';

        // ── Temp token ────────────────────────────────────────────────────────

        function _getTempToken() {
            var cached = sessionStorage.getItem('temp_token');
            if (cached) {
                return $q.resolve(cached);
            }

            return $http.post(BASE_URL + '/temp-auth')
                .then(function (response) {
                    var token = response.data.access_token;
                    sessionStorage.setItem('temp_token', token);
                    console.log('✅ [TwoFaService] Temp token fetched');
                    return token;
                })
                .catch(function (error) {
                    console.error('🚨 [TwoFaService] Failed to fetch temp token:', error.status);
                    return $q.reject(error);
                });
        }

        // ── Métodos base internos ─────────────────────────────────────────────

        function _doGenerateToken(email, targetNumber, extraConfig) {
            var url = BASE_URL + '/2fa-generation';

            return _getTempToken()
                .then(function (token) {
                    var config = angular.extend({}, extraConfig || {}, {
                        headers: angular.extend(
                            { Authorization: 'Bearer ' + token },
                            (extraConfig && extraConfig.headers) || {}
                        )
                    });

                    var payload = { email: email };
                    if (targetNumber) {
                        payload.targetNumber = targetNumber;
                    }

                    return $http.post(url, payload, config);
                })
                .then(function (response) {
                    console.log('🔐 [TwoFaService] Token generated for:', email, '| expires at:', response.data.expiresAt);
                    return response.data;
                })
                .catch(function (error) {
                    console.warn('🔐 [TwoFaService] Token generation failed:', error.status, error.statusText);
                    return $q.reject(error);
                });
        }

        function _doValidateToken(email, code, extraConfig) {
            var url = BASE_URL + '/2fa-code-validation';

            return _getTempToken()
                .then(function (token) {
                    var config = angular.extend({}, extraConfig || {}, {
                        headers: angular.extend(
                            { Authorization: 'Bearer ' + token },
                            (extraConfig && extraConfig.headers) || {}
                        )
                    });

                    return $http.post(url, { email: email, code: code }, config);
                })
                .then(function (response) {
                    console.log('✅ [TwoFaService] Token validated for:', email);
                    return response.data;
                })
                .catch(function (error) {
                    console.warn('❌ [TwoFaService] Token validation failed:', error.status, error.data && error.data.error_code);
                    return $q.reject(error);
                });
        }

        // ── API pública ───────────────────────────────────────────────────────

        this.generateToken = function (email) {
            return _doGenerateToken(email, null, null);
        };

        this.generateTokenWithNumber = function (email, targetNumber) {
            return _doGenerateToken(email, targetNumber, null);
        };

        this.generateTokenWithHeaders = function (config, email) {
            return _doGenerateToken(email, null, config);
        };

        this.generateTokenWithNumberAndHeaders = function (config, email, targetNumber) {
            return _doGenerateToken(email, targetNumber, config);
        };

        this.validateToken = function (email, code) {
            return _doValidateToken(email, code, null);
        };

        this.validateTokenWithHeaders = function (config, email, code) {
            return _doValidateToken(email, code, config);
        };

    }
]);